import _ from 'lodash'

// import i18n from 'scoreboard/components/i18n'
import Wizard from 'scoreboard/components/wizard'

import FetchNewDataForm from './fetch-new-data-form'
import NewColumnNameChooser from 'scoreboard/imports/new-column-name-chooser'

/**
 * Displays a view that could cause a Dataset's column names to change. If this
 * occurs, the view will be converted to a wizard that allows the user to map
 * the new column names to the old ones so everything works correctly
 */
const FetchNewDataWizard = Wizard.extend({

	showMappings: false,

	/**
	 * @param {Object} view the main view to display
	 * @param {String} [options.url] the endpoint to talk to when the user
	 * 		re-submits the form
	 * @param {Function} [options.paramProvider] provides the parameters needed
	 * 		when re-submitting the form
	 */
	initialize(options = {}) {
		let views = this.getViews()
		let opts = {
			views,
			renderAsDialog: true,
			noConfirmation: true
		}
		opts = _.extend(opts, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	showNextStep(show) {
		if (this.showMappings != show) {
			this.showMappings = show
			this.setViews(this.getViews())
			this.render()
		}
	},

	/**
	 * @param submitHandler performs the submit action on the 'new-column-name-chooser'
	 * screen instead of the default action
	 */
	setSubmitHandler(submitHandler) {
		this.submitHandler = submitHandler
	},

	next: function() {
		this.setViews(this.getViews())
		Wizard.prototype.next.apply(this, arguments)
	},

	getViews: function() {
		let views = [ FetchNewDataForm ]
		if (this.showMappings) {
			views.push(NewColumnNameChooser)
		}
		return views
	},

	/**
	 * @param model the resulting data from the server
	 */
	finish: function(model) {
		this.trigger('done', model)
	}
})

export default FetchNewDataWizard
FetchNewDataWizard.__filename__ = 'datasets/fetch-new-data-wizard.js'
